import { IDocumentType } from "store/lobby/lobby-model";
import Request from "utils/requests/api";
import initializeConfig from "utils/requests/api.config";
import RequestNoCredentials from "utils/requests/api.noCredentials";

export const URL_BASE = async () => {
  const { management } = await initializeConfig();
  return `${management}`;
};

interface IProcesses {
  id: number;
  vehicleStepId: string[];
}

interface IRequestLocationActives {
  actives?: boolean;
  structureId?: number;
}

export interface IRequestPostLocation {
  description: string;
  companyDocument?: string;
  country: string;
  addressState: string;
  city: string;
  code: string;
  active: boolean;
  processes: IProcesses[];
  id?: number;
  structureId: number;
  hasCheckin?: boolean;
  hasAttendance?: boolean;
  checkinExpirationTime?: number;
  allowRequestDockEntryAction?: boolean;
  allowRequestVehicleInboundAction?: boolean;
  hasFinishOperationActionActive?: boolean;
  allowRequestVehicleEntryAuthorizationAction?: boolean;
  allowVehicleArrivalConfirmAction?: boolean;
  hasReleaseWMSDocuments?: boolean;
  hasLocationOutOfRange?: boolean;
  hasCheckinSchedule: boolean;
  dropHookTypeOfYard: number;
  hasEntryPermission: boolean;
  documentType: IDocumentType;
  hasRfidReading: boolean;
  plateFormatType: number;
}

export interface IRequestLocation {
  orderBy: string;
  ascending: boolean;
  _size: number;
  _page: number;
  filter: string;
}

export interface IRequestStructureByLocation {
  locationId: number;
}

export const getLocation = async () => {
  const baseUrl = await URL_BASE();
  return (await Request).get(`${baseUrl}locations`);
};

export const getLocationActivePublic = async ({ actives, structureId }: IRequestLocationActives) => {
  const baseUrl = await URL_BASE();
  return (await RequestNoCredentials).get(`${baseUrl}locations:public`, { actives, structureId });
};

export const getLocationActive = async ({ actives, structureId }: IRequestLocationActives) => {
  const baseUrl = await URL_BASE();
  return (await Request).get(`${baseUrl}locations`, { actives, structureId });
};

export const createLocation = async (params: IRequestPostLocation) => {
  const baseUrl = await URL_BASE();
  return (await Request).post(`${baseUrl}locations`, params);
};

export const updateLocation = async (params: IRequestPostLocation) => {
  const baseUrl = await URL_BASE();
  return (await Request).put(`${baseUrl}locations`, params);
};

export const getProcesses = async () => {
  const baseUrl = await URL_BASE();
  return (await Request).get(`${baseUrl}processes:all`);
};

export const getLocationById = async ({ id }) => {
  const baseUrl = await URL_BASE();
  return (await Request).get(`${baseUrl}locations/${id}`);
};

export const getStructures = async () => {
  const baseUrl = await URL_BASE();
  return (await Request).get(`${baseUrl}structures`);
};

export const getAllStructures = async () => {
  const baseUrl = await URL_BASE();
  return (await Request).get(`${baseUrl}structures/summary`);
};

export const getStructureByLocation = async ({ locationId }: IRequestStructureByLocation) => {
  const baseUrl = await URL_BASE();
  return (await Request).get(`${baseUrl}structures/get-by-location`, { locationId });
};

export const getLocationHasConfiguration = async ({ id }) => {
  const baseUrl = await URL_BASE();
  return (await Request).get(`${baseUrl}locations:info/${id}`);
};

export const getLocationRegister = async ({ orderBy, ascending, _size, _page, filter }: IRequestLocation) => {
  const baseUrl = await URL_BASE();
  return (await Request).get(`${baseUrl}locations:paginated`, {
    orderBy,
    ascending,
    _size,
    _page,
    filter,
  });
};
